(function () {
  'use strict';
  if (window.__kiltrStarted) return; /* never run twice on one page */
  window.__kiltrStarted = true;
  var dataEl = document.getElementById('kiltr-data');
  var root = document.getElementById('kiltr-app');
  if (!dataEl || !root) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { root.innerHTML = '<p class="kl-error">Kiltr could not load. Please refresh.</p>'; return; }
  var S = data.settings || {};
  /* Every id becomes text. Shopify may send them as numbers, but an id read back from a tapped tile is always text, and the two must compare equal. */
  function sid(v) { return v == null ? '' : String(v); }
  function fixAnswer(a) { a.id = sid(a.id); a.question_id = sid(a.question_id); return a; }
  var flat = (data.answers || []).map(fixAnswer);
  function shuffle(arr) { for (var i = arr.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = arr[i]; arr[i] = arr[j]; arr[j] = t; } return arr; }
  var questions = (data.questions || []).map(function (q) {
    q.id = sid(q.id);
    (q.answers || []).forEach(fixAnswer);
    var ans = (q.answers && q.answers.length) ? q.answers : flat.filter(function (a) { return a.question_id === q.id; });
    ans = ans.slice().sort(function (a, b) { return a.order - b.order; });
    /* Answers are shuffled on every visit, except the multi-pick question and the spice question (its answers run from mild to hot). */
    if ((q.max_picks || 1) <= 1 && q.kind !== 'Spice') ans = shuffle(ans);
    q.answers = ans;
    return q;
  }).sort(function (a, b) { return a.order - b.order; });
  var total = questions.length;

  /* Every answer by its id, so scoring can look up chillies. */
  var answerById = {};
  questions.forEach(function (q) { q.answers.forEach(function (a) { answerById[a.id] = a; }); });
  flat.forEach(function (a) { if (!answerById[a.id]) answerById[a.id] = a; });

  /* Heroes: only Active heroes reach the page. Each one carries the answers that fit him. */
  var heroes = (data.heroes || []).map(function (h) {
    h.id = sid(h.id);
    h.strong = {}; (h.answers_strong || []).forEach(function (id) { h.strong[sid(id)] = true; });
    h.light = {}; (h.answers_light || []).forEach(function (id) { h.light[sid(id)] = true; });
    h.interests = h.interests || [];
    h.what_i_bring = h.what_i_bring || [];
    h.prompts = [];
    [1, 2, 3].forEach(function (n) {
      var qn = h['prompt_' + n + '_question'], an = h['prompt_' + n + '_answer'];
      if (qn && an) h.prompts.push({ heading: qn, line: an });
    });
    return h;
  });
  var heroCount = heroes.length;

  /* Fetch an image early so the screen that needs it appears at once. */
  function preload(src) { if (src) { var im = new Image(); im.src = src; } }

  /* Screens: -1 welcome · 0..total-1 questions · total scanning · total+1 match cards · total+2 the match screen. */
  var SCAN = total, CARDS = total + 1, LIKED = total + 2;
  var state = { step: -1, picks: {}, ranked: [], offset: 0, matches: [], card: 0, photo: 0, liked: null };
  var scanTimer = null, lineTimer = null;
  var lockUntil = 0; /* taps are ignored for a moment after a single-pick tap, so a double tap can't skip a question */

  /* Picking rule for a question. Single pick: the tapped answer replaces the old one.
     Multi pick: tap to add, tap again to remove; at the limit, the newest tap replaces the oldest pick. */
  function togglePick(current, id, max) {
    if (max <= 1) return [id];
    var next = current.slice();
    var at = next.indexOf(id);
    if (at > -1) { next.splice(at, 1); return next; }
    while (next.length >= max) next.shift();
    next.push(id);
    return next;
  }

  /* Scoring, exactly as the Scoring and match chart tab says. */
  function score(picks) {
    var totals = {};
    heroes.forEach(function (h) { totals[h.id] = 0; });
    questions.forEach(function (q) {
      var picked = picks[q.id] || [];
      picked.forEach(function (id) {
        var a = answerById[id];
        heroes.forEach(function (h) {
          if (q.kind === 'Spice') {
            if (a && typeof a.chillies === 'number' && typeof h.chillies === 'number') {
              var diff = Math.abs(a.chillies - h.chillies);
              totals[h.id] += diff === 0 ? 2 : (diff === 1 ? 1 : 0);
            }
          } else if (h.strong[id]) {
            totals[h.id] += q.points || 0;
          } else if (h.light[id]) {
            totals[h.id] += 1;
          }
        });
      });
    });
    var ranked = shuffle(heroes.slice());
    ranked.sort(function (a, b) { return totals[b.id] - totals[a.id]; });
    return ranked.map(function (h) { return { hero: h, score: totals[h.id] }; });
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function bookTitle(t) { return String(t || '').replace(/,\s*e-?book\s*$/i, ''); }

  var ICON = {
    pin: '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"></path><circle cx="12" cy="9.5" r="2.5"></circle></svg>',
    tick: '<svg role="img" aria-label="Verified: happy ending guaranteed" width="20" height="20" viewBox="0 0 22 22"><circle cx="11" cy="11" r="10" fill="#ffffff"></circle><path d="M6.5 11.5l3 3 6-6.5" fill="none" stroke="#066b75" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
    height: '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 3v18M8 7l4-4 4 4M8 17l4 4 4-4"></path></svg>',
    chilli: '<svg aria-hidden="true" class="kl-chilli" width="14" height="16" viewBox="0 0 24 28"><path d="M20 4c-3 0-5 2-6 5" fill="none" stroke="#2f8f4e" stroke-width="2.4" stroke-linecap="round"></path><path d="M14 9c4 1 6 5 5 9-1.5 5-7 8-12 9-3 .6-5-.6-4-2 .8-1.2 3-1 4-3 1.5-3 .5-7 2-10 1-2 3-3.5 5-3z" fill="#ee3176"></path></svg>',
    search: '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="6"></circle><path d="M20 20l-4.5-4.5"></path></svg>',
    cross: '<svg aria-hidden="true" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#066b75" stroke-width="2.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"></path></svg>',
    heart: '<svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="#ffffff"><path d="M12 21s-7.5-4.6-9.4-9.1C1.3 8.6 3.4 5 6.9 5c2.1 0 3.8 1.2 5.1 3 1.3-1.8 3-3 5.1-3 3.5 0 5.6 3.6 4.3 6.9C19.5 16.4 12 21 12 21z"></path></svg>'
  };

  function footer() {
    return '<footer class="kl-foot"><nav><a href="' + esc(S.shop_url) + '">' + esc(S.back_to_shop) + '</a><span>·</span><a href="' + esc(S.privacy_url) + '">' + esc(S.privacy_label) + '</a></nav><p>' + esc(S.disclaimer) + '</p></footer>';
  }
  function topbar(showBack, rightText) {
    var right = rightText ? '<span class="kl-top-count">' + esc(rightText) + '</span>' : '<span class="kl-top-spacer"></span>';
    var logo = (state.step >= LIKED && S.logo_match) ? S.logo_match : S.logo; /* blush logo on the teal match screen */
    return '<header class="kl-top">' + (showBack ? '<button class="kl-back" type="button" data-act="back" aria-label="Back">‹</button>' : '<span class="kl-top-spacer"></span>') + '<img class="kl-top-logo" src="' + esc(logo) + '" alt="Kiltr">' + right + '</header>';
  }
  function progress(i) {
    var pct = total ? Math.round((i / total) * 100) : 0;
    return '<div class="kl-progress" role="progressbar" aria-valuemin="0" aria-valuemax="' + total + '" aria-valuenow="' + i + '"><span style="width:' + pct + '%"></span></div>';
  }
  function chips(items, cls) {
    return items.map(function (t) { return '<span class="' + cls + '">' + esc(t) + '</span>'; }).join('');
  }

  function renderWelcome() {
    var pic = S.welcome_image ? '<img class="kl-welcome-pic" src="' + esc(S.welcome_image) + '" alt="">' : '';
    return '<main class="kl-screen kl-welcome"><img class="kl-logo" src="' + esc(S.logo) + '" alt="Kiltr"><h1 class="kl-tagline">' + esc(S.tagline) + '</h1>' + pic + '<button class="kl-btn" type="button" data-act="start">' + esc(S.start_button) + '</button><p class="kl-small">' + esc(S.small_print) + '</p></main>' + footer();
  }
  function renderQuestion(i) {
    var q = questions[i];
    var picked = state.picks[q.id] || [];
    var multi = q.max_picks > 1;
    var isPic = q.kind === 'Profile picture';
    var tiles = q.answers.map(function (a) {
      var sel = picked.indexOf(a.id) > -1;
      var cls = 'kl-tile' + (isPic ? ' kl-tile--pic' : '') + (sel ? ' is-selected' : '');
      var inner = isPic
        ? '<span class="kl-tile-img"><img src="' + esc(a.image || '') + '" alt="" loading="lazy"></span><span class="kl-tile-label">' + esc(a.text) + '</span>'
        : '<span class="kl-tile-text">' + esc(a.text) + '</span>';
      return '<button type="button" class="' + cls + '" data-act="pick" data-answer="' + esc(a.id) + '" aria-pressed="' + sel + '">' + inner + '</button>';
    }).join('');
    var hintText = 'Pick up to ' + q.max_picks + ' · ' + picked.length + ' picked';
    var hint = multi ? '<p class="kl-hint">' + hintText + '</p>' : '';
    var next = multi ? '<button type="button" class="kl-btn" data-act="next"' + (picked.length ? '' : ' disabled') + '>Next</button>' : '';
    return topbar(true) + progress(i) + '<main class="kl-screen kl-question"><h2 class="kl-q">' + esc(q.question) + '</h2>' + hint + '<div class="kl-grid' + (isPic ? ' kl-grid--pics' : '') + '">' + tiles + '</div>' + next + '</main>' + footer();
  }
  var SCAN_LINES = ['Checking who\'s single…', 'Ironing the kilts…', 'Asking around the pub…'];
  function herPicture() {
    for (var i = 0; i < questions.length; i++) {
      var q = questions[i];
      if (q.kind !== 'Profile picture') continue;
      var p = state.picks[q.id] || [];
      var a = answerById[p[0]];
      return a && a.image ? a.image : null;
    }
    return null;
  }
  function renderScan() {
    var pic = herPicture();
    var inner = '<div class="kl-scan-ring"><div class="kl-spinner kl-spinner--big" aria-hidden="true"></div>' + (pic ? '<img class="kl-scan-pic" src="' + esc(pic) + '" alt="">' : '') + '</div>';
    return topbar(true) + progress(total) + '<main class="kl-screen kl-end kl-scan">' + inner + '<h2 class="kl-q">Scanning Scotland…</h2><p class="kl-small kl-scan-line" aria-live="polite">' + esc(SCAN_LINES[0]) + '</p></main>' + footer();
  }
  function renderCard() {
    var m = state.matches[state.card];
    if (!m) {
      /* She crossed every card in this round. */
      var left = state.ranked.length - (state.offset + state.matches.length);
      if (left > 0) {
        return topbar(true) + '<main class="kl-screen kl-end">' + (S.fish_image ? '<img class="kl-fish" src="' + esc(S.fish_image) + '" alt="">' : '') + '<h2 class="kl-q">There\'s plenty more fish in the loch</h2><p class="kl-small">None of those three? Scotland\'s a big place.</p><button class="kl-btn" type="button" data-act="more">Show me ' + Math.min(3, left) + ' more</button><button class="kl-btn kl-btn--ghost" type="button" data-act="restart">Start again</button></main>' + footer();
      }
      return topbar(true) + '<main class="kl-screen kl-end"><h2 class="kl-q">That\'s every Scot we\'ve got.</h2><p class="kl-small">Answer a little differently and see who turns up.</p><button class="kl-btn" type="button" data-act="restart">Start again</button></main>' + footer();
    }
    var h = m.hero;
    var photos = [h.photo_1, h.photo_2].filter(Boolean);
    var pi = Math.min(state.photo, photos.length - 1);
    var dots = photos.length > 1 ? '<div class="kl-dots" aria-hidden="true">' + photos.map(function (p, i) { return '<span' + (i === pi ? ' class="is-on"' : '') + '></span>'; }).join('') + '</div>' : '';
    var nameLine = esc(h.name) + (h.age ? ', ' + esc(h.age) : '');
    var photoAlt = esc(h.name) + (pi === 1 ? ' in his kilt' : '');
    var photoHtml = '<div class="kl-photo"><img src="' + esc(photos[pi] || '') + '" alt="' + photoAlt + '">' + dots
      + (photos.length > 1 ? '<button type="button" class="kl-photo-tap kl-photo-tap--left" data-act="photo-prev" aria-label="Previous photo"></button><button type="button" class="kl-photo-tap kl-photo-tap--right" data-act="photo-next" aria-label="Next photo"></button>' : '')
      + '<div class="kl-photo-fade"></div><div class="kl-photo-text"><div class="kl-name">' + nameLine + ' ' + ICON.tick + '</div>'
      + (h.job ? '<div class="kl-job">' + esc(h.job) + '</div>' : '')
      + (h.location ? '<div class="kl-loc">' + ICON.pin + '<span>' + esc(h.location) + '</span></div>' : '')
      + '</div>' + (S.badge_icon ? '<div class="kl-badge"><img src="' + esc(S.badge_icon) + '" alt=""></div>' : '') + '</div>';

    var facts = [];
    if (h.height) facts.push('<span class="kl-chip">' + ICON.height + esc(h.height) + '</span>');
    if (typeof h.chillies === 'number' && h.chillies > 0) { var cs = ''; for (var ci = 0; ci < h.chillies; ci++) cs += ICON.chilli; facts.push('<span class="kl-chip kl-chip--heat" aria-label="Third date: ' + h.chillies + ' of 5 chillies">Third date: <span class="kl-chillies">' + cs + '</span></span>'); }
    if (h.looking_for) facts.push('<span class="kl-chip">' + ICON.search + 'Looking for: ' + esc(h.looking_for) + '</span>');
    if (h.last_active) facts.push('<span class="kl-chip kl-chip--active"><i></i>' + esc(h.last_active) + '</span>');

    var prompts = h.prompts.map(function (p) { return '<div class="kl-prompt"><div class="kl-prompt-h">' + esc(p.heading) + '…</div><div class="kl-prompt-a">' + esc(p.line) + '</div></div>'; }).join('');
    var details = '<div class="kl-card-body">'
      + (h.bio ? '<p class="kl-bio">' + esc(h.bio) + '</p>' : '')
      + (facts.length ? '<div class="kl-chips">' + facts.join('') + '</div>' : '')
      + prompts
      + (h.interests.length ? '<div class="kl-sec"><div class="kl-sec-h">Interests</div><div class="kl-chips">' + chips(h.interests, 'kl-chip kl-chip--line') + '</div></div>' : '')
      + (h.what_i_bring.length ? '<div class="kl-sec"><div class="kl-sec-h">What I bring</div><div class="kl-chips">' + chips(h.what_i_bring, 'kl-chip kl-chip--line') + '</div></div>' : '')
      + (h.fair_warning ? '<p class="kl-warn"><strong>Fair warning:</strong> ' + esc(h.fair_warning) + '</p>' : '')
      + '</div>';

    var counter = (state.card + 1) + ' of ' + state.matches.length;
    return topbar(true, counter) + '<main class="kl-screen kl-cards"><article class="kl-card" aria-label="' + esc(h.name) + '\'s profile">' + photoHtml + details + '</article>'
      + '<div class="kl-actions"><button type="button" class="kl-round kl-round--no" data-act="nope" aria-label="Not for me, next match">' + ICON.cross + '</button><button type="button" class="kl-round kl-round--yes" data-act="like" aria-label="Yes, match with ' + esc(h.name) + '">' + ICON.heart + '</button></div></main>' + footer();
  }
  function heartsBurst() {
    var out = '';
    for (var i = 0; i < 14; i++) {
      var ang = (i / 14) * Math.PI * 2 + (i % 2 ? 0.2 : -0.1);
      var dist = 70 + (i % 3) * 28;
      var dx = Math.round(Math.cos(ang) * dist), dy = Math.round(Math.sin(ang) * dist) - 20;
      out += '<i style="--dx:' + dx + 'px;--dy:' + dy + 'px;--d:' + (i * 35) + 'ms;--s:' + (0.6 + (i % 4) * 0.18) + '">' + ICON.heart + '</i>';
    }
    return '<div class="kl-burst" aria-hidden="true">' + out + '</div>';
  }
  function priceHtml(p) {
    if (!p || !p.price) return '';
    return '<div class="kl-price"><strong>' + esc(p.price) + '</strong>' + (p.compare_at_price ? ' <s>' + esc(p.compare_at_price) + '</s>' : '') + '</div>';
  }
  function renderLiked() {
    var h = state.liked;
    if (!h) { return topbar(true) + '<main class="kl-screen kl-end"><h2 class="kl-q">Nobody here yet.</h2><button class="kl-btn kl-btn--ghost" type="button" data-act="restart">Start again</button></main>' + footer(); }
    var her = herPicture();
    var head = S.match_image ? '<h1 class="kl-match-head"><img class="kl-match-logo" src="' + esc(S.match_image) + '" alt="It\'s a match!"></h1>' : '<h1 class="kl-match-head kl-match-text">It\'s a match!</h1>';
    var circles = '<div class="kl-pair">' + heartsBurst()
      + '<span class="kl-pair-pic kl-pair-pic--her">' + (her ? '<img src="' + esc(her) + '" alt="Your profile picture">' : '') + '</span>'
      + '<span class="kl-pair-pic kl-pair-pic--him">' + (h.photo_1 ? '<img src="' + esc(h.photo_1) + '" alt="' + esc(h.name) + '">' : '') + '</span>'
      + '<span class="kl-pair-heart">' + ICON.heart + '</span></div>';
    var why = h.why_him ? '<section class="kl-box kl-box--blush kl-box--why"><h2 class="kl-box-h">Why he\'s the one for you</h2><p class="kl-why-line">' + ICON.heart + '<span>' + esc(h.why_him) + '</span></p></section>' : '';
    var book = h.book || {};
    var free = !!(h.free_now && h.free_signup_url);
    var bookHtml = '<section class="kl-box"><h2 class="kl-box-h kl-box-h--big">Meet ' + esc(h.name) + '</h2><div class="kl-pitch">' + (h.pitch_html || '') + '</div>'
      + '<div class="kl-book">' + (book.image ? '<img class="kl-cover" src="' + esc(book.image) + '" alt="">' : '<span class="kl-cover kl-cover--empty"></span>')
      + '<div class="kl-book-text"><div class="kl-eyebrow">' + esc(h.name) + '\'s story</div><div class="kl-book-title">' + esc(bookTitle(book.title)) + '</div>'
      + (h.series_line ? '<div class="kl-book-line">' + esc(h.series_line) + '</div>' : '') + '<div class="kl-book-line">Reads as a standalone</div>'
      + (free ? '' : priceHtml(book)) + '</div></div>'
      + (free ? '<p class="kl-free">You\'re in luck: it\'s free right now if you sign up for my newsletter.</p><a class="kl-btn kl-btn--block" href="' + esc(h.free_signup_url) + '">Get it free</a>'
              : (book.url ? '<a class="kl-btn kl-btn--block kl-btn--teal" href="' + esc(book.url) + '">Start your love story</a>' : ''))
      + '</section>';
    var up = h.upsell;
    var upHtml = up && up.url ? '<section class="kl-box kl-box--blush kl-upsell"><div class="kl-upsell-text"><h2 class="kl-box-h">' + esc(h.upsell_line || 'You might also like') + '</h2><div class="kl-book-line">' + esc(bookTitle(up.title)) + '</div>' + priceHtml(up) + '</div><a class="kl-btn kl-btn--small" href="' + esc(up.url) + '">Take a look</a></section>' : '';
    return topbar(true) + '<main class="kl-screen kl-match">' + head + '<p class="kl-match-sub">You and ' + esc(h.name) + ' liked each other.</p>' + circles + why + bookHtml + upHtml
      + '<div class="kl-match-links"><button type="button" class="kl-link" data-act="back">See my other matches</button><button type="button" class="kl-link" data-act="restart">Start again</button></div></main>' + footer();
  }
  function render(keepScroll) {
    var h;
    if (state.step < 0) h = renderWelcome();
    else if (state.step === SCAN) h = renderScan();
    else if (state.step === CARDS) h = renderCard();
    else if (state.step >= LIKED) h = renderLiked();
    else h = renderQuestion(state.step);
    root.innerHTML = h;
    root.classList.toggle('is-welcome', state.step < 0);
    root.classList.toggle('is-match', state.step >= LIKED);
    if (keepScroll) return;
    var scroller = root.querySelector('.kl-screen');
    if (scroller) scroller.scrollTop = 0;
    var card = root.querySelector('.kl-card');
    if (card) card.scrollTop = 0;
    window.scrollTo(0, 0);
    var focus = root.querySelector('h1,h2,.kl-name');
    if (focus && focus.classList.contains('kl-match-head')) focus = root.querySelector('.kl-match-sub') || focus;
    if (focus) { focus.setAttribute('tabindex', '-1'); try { focus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function go(step, mode) {
    state.step = step;
    stopScan();
    if (mode !== false) {
      try { if (mode === 'replace') history.replaceState({ kiltr: step }, ''); else history.pushState({ kiltr: step }, ''); } catch (e) {}
    }
    render();
    if (step === SCAN) startScan();
  }
  function stopScan() {
    if (scanTimer) { clearTimeout(scanTimer); scanTimer = null; }
    if (lineTimer) { clearInterval(lineTimer); lineTimer = null; }
  }
  function startScan() {
    state.ranked = score(state.picks).map(function (r) { return r.hero; });
    state.offset = 0;
    state.matches = state.ranked.slice(0, 3).map(function (hero) { return { hero: hero }; });
    state.card = 0; state.photo = 0; state.liked = null;
    state.matches.forEach(function (m) { preload(m.hero.photo_1); preload(m.hero.photo_2); if (m.hero.book) preload(m.hero.book.image); });
    var li = 0;
    lineTimer = setInterval(function () {
      li = (li + 1) % SCAN_LINES.length;
      var el = root.querySelector('.kl-scan-line');
      if (el) el.textContent = SCAN_LINES[li];
    }, 800);
    /* Replace the scanning screen in history, so the browser's back button from the cards goes to the last question. */
    scanTimer = setTimeout(function () { scanTimer = null; go(CARDS, 'replace'); }, 2400);
  }
  function finishQuestions() {
    if (!heroCount) { go(CARDS); return; }
    go(SCAN);
  }
  function showCard(i) { state.card = i; state.photo = 0; render(); }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-act]');
    if (!btn) return;
    var act = btn.getAttribute('data-act');
    if (Date.now() < lockUntil) return;
    if (act === 'start') { go(0); }
    else if (act === 'back') {
      if (state.step === CARDS && state.card > 0) { showCard(state.card - 1); }
      else { history.back(); }
    }
    else if (act === 'restart') { state.picks = {}; state.ranked = []; state.offset = 0; state.matches = []; state.card = 0; state.photo = 0; state.liked = null; go(-1); }
    else if (act === 'next') { if (state.step === total - 1) finishQuestions(); else go(state.step + 1); }
    else if (act === 'photo-next') { state.photo = Math.min(state.photo + 1, 1); render(); }
    else if (act === 'photo-prev') { state.photo = Math.max(state.photo - 1, 0); render(); }
    else if (act === 'nope') { showCard(state.card + 1); }
    else if (act === 'more') {
      state.offset += state.matches.length;
      state.matches = state.ranked.slice(state.offset, state.offset + 3).map(function (hero) { return { hero: hero }; });
      state.matches.forEach(function (x) { preload(x.hero.photo_1); preload(x.hero.photo_2); });
      showCard(0);
    }
    else if (act === 'like') { var m = state.matches[state.card]; state.liked = m ? m.hero : null; go(LIKED); }
    else if (act === 'pick') {
      var q = questions[state.step];
      if (!q) return;
      var id = btn.getAttribute('data-answer');
      state.picks[q.id] = togglePick(state.picks[q.id] || [], id, q.max_picks || 1);
      render(true); /* every tile, the hint and Next are redrawn from the saved picks */
      if ((q.max_picks || 1) <= 1) {
        lockUntil = Date.now() + 400;
        setTimeout(function () { if (state.step === total - 1) finishQuestions(); else go(state.step + 1); }, 260);
      }
    }
  });

  window.addEventListener('popstate', function (e) {
    var st = (e.state && typeof e.state.kiltr === 'number') ? e.state.kiltr : -1;
    stopScan();
    lockUntil = 0;
    if (st === SCAN) { st = total - 1; }
    if (st === CARDS && !state.matches.length) { st = total - 1; }
    if (st >= LIKED && !state.liked) { st = state.matches.length ? CARDS : total - 1; }
    state.step = st;
    render();
  });

  preload(S.match_image); preload(S.badge_icon); preload(S.logo_match); preload(S.fish_image);
  try { history.replaceState({ kiltr: -1 }, ''); } catch (e) {}
  render();
})();
